module.exports = __webpack_public_path__ + "e37f5167f23343f4849bf6db224196c6.svg";